import { render, staticRenderFns } from "./FluxoDeCaixa.vue?vue&type=template&id=43c96154&"
import script from "./FluxoDeCaixa.vue?vue&type=script&lang=js&"
export * from "./FluxoDeCaixa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports